/**
 * Analytics event tracking wrapper for GA4 + Microsoft Clarity.
 * Safe to call even if GA4/Clarity scripts aren't loaded (graceful no-op).
 */

export function trackEvent(eventName, params = {}) {
  try {
    // Google Analytics 4
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch {
    // silent
  }
}

// Pre-built event helpers
export const analytics = {
  stockSearch: (query) => trackEvent("stock_search", { search_term: query }),
  stockDetailView: (ticker) => trackEvent("stock_detail_view", { ticker }),
  watchlistAdd: (ticker) => trackEvent("watchlist_add", { ticker }),
  watchlistRemove: (ticker) => trackEvent("watchlist_remove", { ticker }),
  csvExport: () => trackEvent("csv_export"),
  filterStatus: (status) => trackEvent("filter_status", { status }),
  filterSector: (sector) => trackEvent("filter_sector", { sector }),
  portfolioScreen: (count) => trackEvent("portfolio_screen", { ticker_count: count }),
  outboundClick: (url) => trackEvent("outbound_click", { url }),
};
